<template>
    <el-container>
      <el-header height="80px">
        <el-menu class="el-menu-demo" :default-active="activeIndex" mode="horizontal" id="elMenu" @select="handleSelect">
          <el-menu-item @click="back()">后退</el-menu-item>
          <el-menu-item index="/jiashaoCableTestIndex">首页</el-menu-item>
          <el-menu-item index="/jiashaoCableTest/currentDataTable?bridgeId=f917c90d-e6bd-484f-9311-bbe0fcf458e9">实时数据表</el-menu-item>
          <el-submenu :index="'/jiashaoCableTest/dataHistory?bridgeId=f917c90d-e6bd-484f-9311-bbe0fcf458e9&scenarioId=TBD'">
            <template slot="title">数据历史</template>
            <el-menu-item index="/jiashaoCableTest/dataHistory?bridgeId=f917c90d-e6bd-484f-9311-bbe0fcf458e9&scenarioId=TBD"> 查询数据历史 </el-menu-item>
            <el-menu-item index="/jiashaoCableTest/dataHistory?bridgeId=f917c90d-e6bd-484f-9311-bbe0fcf458e9"> 自定义数据历史 </el-menu-item>
          </el-submenu>
        </el-menu>
        <HeaderTime bridgeName="JIASHAO" :bridgeId="bridgeId" :id2Path="id2Path" :envInfo="envInfo"></HeaderTime>
      </el-header>
      <el-main class="el-main jiashao">
        <router-view></router-view>
      </el-main>
    </el-container>
  </template>
    <script>
  export default {
    name: "jiashao",
    data() {
      return {
        bridgeId: "f917c90d-e6bd-484f-9311-bbe0fcf458e9",
        envInfo: {
          envId: "3ea77029-336c-49a5-b94c-36827f1a7687",
          weather: "ffeae9e6-5c96-4c15-8e94-ecac58d6e6df",
          humidity: "ada764f0-7d44-4e9b-8959-5e9fced8a72c",
          temperature: "1788bd46-c71c-4d9b-8c94-1f6243ad856e",
        },
        id2Path: {},
        activeIndex: "",
        historyScenarioList: [],
      };
    },
    mounted() {
      this.activeIndex = this.$route.fullPath;
  
      document.getElementById("elMenu").addEventListener(
        "mousewheel",
        (e) => {
          let scrollWidth = document.getElementById("elMenu").scrollWidth;
          let clientWidth = document.getElementById("elMenu").clientWidth;
  
          let scrollMin = 0;
          let scrollMax = scrollWidth - clientWidth;
          let step = 30;
  
          if (e.deltaY > 0) {
            document.getElementById("elMenu").scrollLeft += step;
            if (document.getElementById("elMenu").scrollLeft > scrollMax) {
              document.getElementById("elMenu").scrollLeft = scrollMax;
            }
          } else if (e.deltaY < 0) {
            document.getElementById("elMenu").scrollLeft += step * -1;
            if (document.getElementById("elMenu").scrollLeft < scrollMin) {
              document.getElementById("elMenu").scrollLeft = scrollMin;
            }
          }
        },
        true
      );
    },
    watch: {
      $route() {
        this.activeIndex = this.$route.fullPath;
      },
    },
    methods: {
      back() {
        window.history.back();
      },
      handleSelect(key) {
        if (key !== this.activeIndex) {
          this.activeIndex = key;
          this.$router.push(key);
        }
      },
    },
  };
  </script>
    
    <style lang="scss" scoped>
  .el-menu-demo {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
  
    overflow-x: scroll;
  }
  
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    background: transparent;
    display: none;
  }
  </style>